import get from 'lodash/get';
import adsSettings from './adsSettings';
import { State, getState } from './applicationState';
import parseUtils from './parseUtils';
export default {
    audioVideoAdDisabled() {
        const options = getState(State.options);
        const audioAdsEnabled = get(options, 'audioads.enabled', true);
        return !(parseUtils.parseBool(audioAdsEnabled) && adsSettings.canShowPrerollAds());
    },
};
